import { api } from "./api";

export const createAssetsMux = async (url: string): Promise<string> => {
  const { data } = await api.generateMuxUrl(url);
  return data.url;
};
